// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"da0a916c","18":"7606f69a","33":"73d935cb","137":"c9af9a42","323":"48b72ef7","649":"4cb443ee"}[chunkId] + ".chunk.js";
};